<template>
  <v-container
    class="pa-0 pa-sm-3">
    <vue-dropzone
      id='new-import-drop'
      ref="importDrop"
      @vdropzone-file-added="importFile"
      :options="importDropzoneOptions"
      :useCustomSlot="true"
      class="my-0"
    >
      <div class="dz-message px-3 my-0" data-dz-message>
        <v-icon
          class="pb-1"
          light
          color="grey darken-">mdi-file</v-icon>
        <br />
        <span>{{ $t('drag_drop_request') }}</span>
      </div>
    </vue-dropzone>
  </v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'

export default {
  name: 'RequestImport',
  components: {
    vueDropzone: vue2Dropzone
  },
  data: vm => ({
    importDropzoneOptions: {
      url: '#',
      autoProcessQueue: false,
      addRemoveLinks: true,
      maxFilesize: 1,
      acceptedFiles: '*/*',
      dictDefaultMessage: '<i class="fa fa-file"></i>' + 'Drag and drop or click to load an existing request!'
    }
  }),
  methods: {
    importFile: function (file) {
      this.$emit('fileImport', file)
      this.$refs.importDrop.removeFile(file)
    }
  }
}
</script>
